import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.index-of.js";
export var statusMapActionToLabel = {
  accept: 'Accepted',
  reject: 'Rejected',
  waitlist: 'Waitlisted',
  program_closed: 'Program Closed'
};
export var getLink = function getLink(info, name) {
  var action = info && info.status && info.status.actions && info.status.actions.find(function (a) {
    return a.name === name;
  });
  return action && action.link;
};

/**
 * Retrieve a string with the latest application status, given an application status object
 * @param application
 * @param validStatuses If present, only these statuses will be considered on the reply
 */
export function getLatestStatus(application, validStatuses) {
  if (!application) {
    return null;
  }
  if (application.status.canceled && (!validStatuses || validStatuses.indexOf('canceled') >= 0)) {
    return 'Canceled';
  }
  if (application.status.withdrawn && (!validStatuses || validStatuses.indexOf('withdrawn') >= 0)) {
    return 'Withdrawn';
  }
  if (application.status.refund_in_progress && (!validStatuses || validStatuses.indexOf('refund_in_progress') >= 0)) {
    return 'Refund in Progress';
  }
  if (application.status.deferral_in_progress && (!validStatuses || validStatuses.indexOf('deferral_in_progress') >= 0)) {
    return 'Deferral in Progress';
  }
  /* Not adding enrollment_confirmed since
    other statuses can still be unchecked
  */
  if (application.status.ready_to_enroll && (!validStatuses || validStatuses.indexOf('ready_to_enroll') >= 0)) {
    return 'Ready to Enroll';
  }
  if (application.status.ready_for_visa && (!validStatuses || validStatuses.indexOf('ready_for_visa') >= 0)) {
    return 'Ready for Visa';
  }
  if (application.status.accepted && (!validStatuses || validStatuses.indexOf('accepted') >= 0)) {
    return 'Accepted';
  }
  if (application.status.rejected && (!validStatuses || validStatuses.indexOf('rejected') >= 0)) {
    return 'Rejected';
  }
  if (application.status.program_closed && (!validStatuses || validStatuses.indexOf('program_closed') >= 0)) {
    return 'Program Closed';
  }
  if (application.status.waitlisted && (!validStatuses || validStatuses.indexOf('waitlisted') >= 0)) {
    return 'Waitlisted';
  }
  if (application.status.submitted && (!validStatuses || validStatuses.indexOf('submitted') >= 0)) {
    return 'Submitted';
  }
  if (application.status.ready_to_submit && (!validStatuses || validStatuses.indexOf('ready_to_submit') >= 0)) {
    return 'Ready to Submit';
  }
  if (application.paid && (!validStatuses || validStatuses.indexOf('paid') >= 0)) {
    return 'Paid';
  }
  return 'Unpaid';
}